<template>
    <div id="app">
        <v-progress-linear style="position: fixed; top: -15px; z-index: 999999;" :indeterminate="true" v-if="loading"></v-progress-linear>
        <transition name="page" mode="out-in">
            <component v-if="layout" :is="layout"></component>
        </transition>
    </div>
</template>

<style lang="scss">
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;
        a {
            font-weight: bold;
            color: #2c3e50;
            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>

<script>
    const requireContext = require.context('@/layouts', false, /.*\.vue$/);

    const layouts = requireContext.keys()
        .map(file =>
            [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
        )
        .reduce((components, [name, component]) => {
            components[name] = component.default;
            return components;
        }, {});

    const default_layout = "basic";

    export default {
        components: {},

        data: () => ({
            defaultLayout: 'basic'
        }),

        metaInfo() {
            const {appName} = this.$store.getters["config/data"];

            return {
                title: appName,
                titleTemplate: `%s · ${appName}`
            }
        },

        computed: {
            layout() {
                return layouts[(this.$route.meta.layout || default_layout)];
            },
            loading() {
                return this.$store.getters["loading/loading"];
            }
        },
    }
</script>